/**
 * El estado del alumno, con color.
 *
 * Usa los colores semánticos del tema y **no** la marca del club: si un club
 * tuviera marca roja, «activo» saldría rojo y la interfaz diría lo contrario de
 * lo que pasa.
 *
 * Y traduce: `active` es un valor de columna, no algo que se le enseñe a nadie.
 */
export function EstadoDeAlumno({ estado }: { estado: string }) {
  const etiquetas: Record<string, string> = {
    active: 'Activo',
    trial: 'En prueba',
    paused: 'En pausa',
    left: 'De baja',
  };

  return (
    <span className={`pastilla pastilla-${estado}`}>
      {etiquetas[estado] ?? estado}
    </span>
  );
}
